import { SelectOption } from '@/components/form-builder/form-builder.types';
import { Scenario, ScenarioDto, StepDto } from '@/types/scenarios.types';
import { createStore, withProps } from '@ngneat/elf';

export interface DacScenariosStateProps {
  response?: Scenario[] | Scenario;
  dto?: ScenarioDto;
  stepDto?: StepDto;
  initialDto?: ScenarioDto;
  isEqual: boolean;
  passingModeSelected?: SelectOption[];
  stepSelected?: SelectOption;
  dossierSelected?: number;
  orderEvaluation?: number;
  modeEvaluationSelected?: SelectOption;
  modeEvaluationOptions?: SelectOption[];
  modeEvaluationFinalOptions?: SelectOption[];
}

export const dacScenariosInitialState: DacScenariosStateProps = {
  dto: {
    nom: '',
    description: '',
    code: '',
    modePassationIds: [],
  },
  stepDto: undefined,
  isEqual: true,
  passingModeSelected: [],
  stepSelected: undefined,
  dossierSelected: undefined,
  orderEvaluation: undefined,
  modeEvaluationSelected: undefined,
  modeEvaluationOptions: [],
  modeEvaluationFinalOptions: [],
};

export const dacScenariosStateStore = createStore(
  { name: 'dac-scenarios-state' },
  withProps<DacScenariosStateProps>({
    ...dacScenariosInitialState,
  })
);
